// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PutProductDetailsRemoveMainProductQuery, BaseResponseVoid } from '../../types';

/**
 * removeMainProduct
 *
 * @export
 * @tags product-detail-controller
 * @link [PUT] /productDetails/removeMainProduct
 */
export function putProductDetailsRemoveMainProduct(
    options: ApiOptions<never, PutProductDetailsRemoveMainProductQuery> & {
        params: PutProductDetailsRemoveMainProductQuery;
    }
): Promise<BaseResponseVoid> {
    return request<never, never, PutProductDetailsRemoveMainProductQuery>(
        '/productDetails/removeMainProduct',
        { ...options, method: 'put', __$requestCalleeName: 'putProductDetailsRemoveMainProduct' }
    );
}

export const meta = [
    {
        tags: ['product-detail-controller'],
        path: '/productDetails/removeMainProduct',
        method: 'put',
    },
];
